export default "__VITE_PUBLIC_ASSET__dd7acbe7__"